:host {
  display: block;
}

* {
  box-sizing: border-box;
}

.header {
  color: #3dcd58;
  font-size: 16px;
  margin: 20px 0;
  font-weight: bold;
  line-height: 1.5625rem;
}

@media screen and (min-width: 980px) {
  .header {
    font-size: 28px;
    margin: 40px auto 20px;
    max-width: 1200px;
    padding: 0 10px;
  }
}

.header--crossSellLife {
  color: #b10043;
}

.content {
  max-width: 1200px;
  margin: 0 -16px;
}

@media screen and (min-width: 980px) {
  .content {
    padding-bottom: 45px;
  }
}

@media screen and (min-width: 1230px) {
  .content {
    margin: 0 auto;
  }
}

.collapsible-container {
  background-color: #f7f7f7;
}

.product__white {
  background-color: white;
}

:host(:not([dir="rtl"])) .product {
  margin-right: 10px;
}

:host([dir="rtl"]) .product {
  margin-left: 10px;
}

@media screen and (max-width: 719px) {
  .product {
    --se-carousel-item-width:
      calc(
        (100% - 10px) / 2
      );
  }
}

@media screen and (min-width: 720px) and (max-width: 980px) {
  .product {
    --se-carousel-item-width:
      calc(
        (100% - 20px) / 3
      );
  }
}

@media screen and (min-width: 980px) {
  .product {
    --se-carousel-item-width:
      calc(
        (100% - 60px) / 4
      );
  }
}

@media screen and (max-width: 1229px) {
  :host(:not([dir="rtl"])) .product:first-child {
    padding-left: 16px;
  }

  :host([dir="rtl"]) .product:first-child {
    padding-right: 16px;
  }

  :host(:not([dir="rtl"])) .product:last-child {
    padding-right: 16px;
  }

  :host([dir="rtl"]) .product:last-child {
    padding-left: 16px;
  }
}

:host(:not([dir="rtl"])) .product:last-child {
  margin-right: 0;
}

:host([dir="rtl"]) .product:last-child {
  margin-left: 0;
}

@media screen and (min-width: 980px) {
  .product {
    height: 140px;
  }

  :host(:not([dir="rtl"])) .product {
    margin-right: 20px;
  }

  :host([dir="rtl"]) .product {
    margin-left: 20px;
  }
}